import React from "react"
import { shallowEqual, useSelector } from "react-redux";
import { FilterGroup } from "../../../../../../Common/components/FilterGroup";
import { GiftCardTable } from "../../../../../../GiftCardManagement/pages/GiftCardTable";

function GiftCards(
    {
        match: {
            params: {
                userId
            }
        }
    }
) {
    const {profile} = useSelector(({ selectedUser }) => {
        const data = selectedUser?.data?.profile?.basic?.userId === userId ? selectedUser.data : null;
        return data;
    }, shallowEqual);

    return (
        <>
            <FilterGroup>
                <FilterGroup.Content>
                    {
                        ({ filters }) => {
                            return <GiftCardTable userGroup={profile?.basic?.userGroup} userId={userId}/>
                        }
                    }
                </FilterGroup.Content>
            </FilterGroup>
        </>
    )
}

export default GiftCards